import React, { useEffect } from 'react';
import { IconCheck, IconX } from './Icons';

export function Modal({ title, children, onClose, footer, size, dialogClassName }) {
  const sizeClass = size === 'lg' ? 'modal-lg' : size === 'sm' ? 'modal-sm' : '';
  const extra = dialogClassName || '';

  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => document.body.classList.remove('modal-open');
  }, []);

  return (
    <>
      <div
        className="modal fade show"
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="adminModalTitle"
        style={{ display: 'block' }}
      >
        <div className={`modal-dialog modal-dialog-centered ${sizeClass} ${extra}`.trim()}>
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="adminModalTitle">
                {title}
              </h1>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            </div>
            <div className="modal-body">{children}</div>
            {footer ? <div className="modal-footer">{footer}</div> : null}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" role="presentation" onClick={onClose} />
    </>
  );
}

export function ConfirmDialog({ title, message, confirmLabel, danger, onConfirm, onCancel, busy }) {
  return (
    <Modal
      title={title}
      onClose={onCancel}
      dialogClassName="modal-confirm"
      footer={
        <div className="d-flex justify-content-center align-items-center gap-4 py-2 w-100 border-0">
          <button
            type="button"
            className="btn btn-confirm-icon btn-confirm-icon-cancel"
            onClick={onCancel}
            disabled={busy}
            aria-label="Cancel"
            title="Cancel"
          >
            <IconX size={26} strokeWidth={2} />
            <span className="visually-hidden">Cancel</span>
          </button>
          <button
            type="button"
            className={`btn btn-confirm-icon ${danger ? 'btn-confirm-icon-danger' : 'btn-confirm-icon-primary'}`}
            onClick={onConfirm}
            disabled={busy}
            aria-label={confirmLabel || 'Confirm'}
            title={confirmLabel || 'Confirm'}
          >
            {busy ? (
              <span className="spinner-border spinner-border-sm text-light" role="status" />
            ) : (
              <IconCheck size={26} strokeWidth={2.25} />
            )}
            <span className="visually-hidden">{busy ? 'Please wait' : confirmLabel || 'Confirm'}</span>
          </button>
        </div>
      }
    >
      <p className="text-secondary mb-0 modal-confirm-message">{message}</p>
    </Modal>
  );
}
